/**
 * AJP PhotoSwipe Integration
 * Developer: Geoff Jackson
 * Email: geoff@alljigsawpuzzles.co.uk
 *
 * IMPORTANT:
 * Dawn dynamically swaps product media when variants change.
 * Because of this, the PhotoSwipe gallery must be rebuilt immediately
 * before opening rather than relying on the gallery generated on page load.
 *
 * This ensures the correct variant media is always opened.
 */

import PhotoSwipeLightbox from './photoswipe-lightbox.esm.js';

document.addEventListener('DOMContentLoaded', async () => {
  if (
    !document.querySelector('.ajp-pswp-button') ||
    !document.querySelector('.ajp-pswp-opener')
  ) {
    console.log('AJP PhotoSwipe: missing buttons or openers');
    return;
  }

  const pswpModulePromise = import('./photoswipe.esm.js');

  const gallery = document.createElement('div');
  gallery.className = 'ajp-pswp-hidden-gallery';
  gallery.style.display = 'none';
  document.body.appendChild(gallery);

  function rebuildPhotoSwipeGallery() {
    gallery.innerHTML = '';

    const currentButtons = Array.from(document.querySelectorAll('.ajp-pswp-button'));

    currentButtons.forEach((button, index) => {
      const link = document.createElement('a');

      link.href = button.dataset.pswpSrc;
      link.className = 'ajp-pswp-trigger';
      link.dataset.pswpWidth = button.dataset.pswpWidth;
      link.dataset.pswpHeight = button.dataset.pswpHeight;
      link.dataset.pswpIndex = index;
      link.dataset.mediaId = button.dataset.mediaId;

      gallery.appendChild(link);
    });

    return currentButtons;
  }

  rebuildPhotoSwipeGallery();

  const lightbox = new PhotoSwipeLightbox({
    gallery: '.ajp-pswp-hidden-gallery',
    children: '.ajp-pswp-trigger',
    pswpModule: () => pswpModulePromise
  });

  lightbox.init();

  function getPhotoSwipeIndex(button) {
    const currentButtons = rebuildPhotoSwipeGallery();

    let index = currentButtons.indexOf(button);
    const mediaId = button.dataset.mediaId;

    if (mediaId) {
      const triggers = Array.from(gallery.querySelectorAll('.ajp-pswp-trigger'));
      const mediaIndex = triggers.findIndex((trigger) => trigger.dataset.mediaId === mediaId);

      if (mediaIndex >= 0) {
        index = mediaIndex;
      }
    }

    return index;
  }

  function openPhotoSwipe(button) {
    if (!button) return;

    const index = getPhotoSwipeIndex(button);

    if (index < 0) return;

    lightbox.loadAndOpen(index);
  }

  function blockDawnModal(event) {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.ajp-pswp-button');

      if (!button) return;

      blockDawnModal(event);
      openPhotoSwipe(button);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const opener = event.target.closest('.ajp-pswp-opener');

      if (!opener) return;

      blockDawnModal(event);

      const button = opener.querySelector('.ajp-pswp-button');
      openPhotoSwipe(button);
    },
    true
  );

  document.addEventListener('contextmenu', (event) => {
    if (event.target.closest('.pswp')) {
      event.preventDefault();
    }
  });
});